/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_EmptyInputs */

const en_us2_gyms_empty = /** @type {(inputs: Gyms_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No gym saved yet. Save what you have ticked above as your first one.`)
};

const pt_br2_gyms_empty = /** @type {(inputs: Gyms_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma academia salva ainda. Salve o que está marcado acima como a primeira.`)
};

const es_419_gyms_empty = /** @type {(inputs: Gyms_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay gimnasios guardados. Guarda lo que marcaste arriba como el primero.`)
};

const pt_pt2_gyms_empty = /** @type {(inputs: Gyms_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não há nenhum ginásio guardado. Guarda o que está marcado acima como o primeiro.`)
};

const fr_fr2_gyms_empty = /** @type {(inputs: Gyms_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune salle enregistrée. Enregistre ce qui est coché plus haut comme ta première.`)
};

const de_de2_gyms_empty = /** @type {(inputs: Gyms_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch kein Studio gespeichert. Speichere die oben markierte Ausstattung als dein erstes.`)
};

const it_it2_gyms_empty = /** @type {(inputs: Gyms_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna palestra salvata. Salva come prima quella che hai selezionato sopra.`)
};

/**
* | output |
* | --- |
* | "No gym saved yet. Save what you have ticked above as your first one." |
*
* @param {Gyms_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_empty = /** @type {((inputs?: Gyms_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_empty(inputs)
	if (locale === "es-419") return es_419_gyms_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_empty(inputs)
	if (locale === "de-DE") return de_de2_gyms_empty(inputs)
	if (locale === "it-IT") return it_it2_gyms_empty(inputs)
	return en_us2_gyms_empty(inputs)
});
export { gyms_empty as "gyms.empty" }